'use es6';

import GoodTagTypes from './GoodTagTypes';
export default {
  SORT_BY: 'sortBy',
  LIMIT: 'limit',
  PAGE: 'page',
  PRICE: 'price',
  SUB_TYPE: 'subType',
  CHILD_TYPES: 'childType',
  CODING_TYPE: GoodTagTypes.COS_TEMPLATE_CODING_TYPE,
  MODULE_COMPATIBILITY: GoodTagTypes.MODULE_COMPATIBILITY,
  MODULE_PURPOSE: GoodTagTypes.MODULE_PURPOSE,
  PAGE_LAYOUT: GoodTagTypes.COS_TEMPLATE_LAYOUT,
  INDUSTRY: GoodTagTypes.INDUSTRY,
  TEMPLATE_PURPOSE: GoodTagTypes.COS_TEMPLATE_INTENT,
  FEATURES: GoodTagTypes.COS_TEMPLATE_FEATURES,
  SEARCH_TERM: 'searchTerm',
  PROVIDER: 'provider'
};